import React, { Component } from "react";
import PropTypes from "prop-types";
import Row from "../../shared_modules/common/grid/Row";
import Col from "../../shared_modules/common/grid/Col";
import ValidationMsg from "../../shared_modules/common/forms/ValidationMsg";

class Name extends Component {
  constructor(props) {
    super(props);

    this.state = {
      msgData: {
        errors: {
          firstname: {},
          lastname: {},
        },
        info: {
          firstname: {},
          lastname: {},
        },
      },
    };
  }

  static defaultProps = {
    element: {
      name: "name",
      firstNameLabel: "First Name",
      lastNameLabel: "Last Name",
      colLabelClassName: "label",
      colFieldClassName: "field",
      colValidationClassName: "messaging",
    },
    nameGroupLabel: "Patient Name",
    nameDisabled: false,
    firstNameMax: 34,
    lastNameMax: 34,
    colLayout: {
      1: { sm: 12, lg: 3 },
      2: { sm: 12, lg: 3 },
      3: { sm: 12, lg: 3 },
      4: { sm: 12, lg: 3 },
    },
  };

  initMsgObj = () => {
    const msgData = {
      errors: {
        firstname: {},
        lastname: {},
      },
      info: {
        firstname: {},
        lastname: {},
      },
    };

    return msgData;
  };

  validKey = (ev) => {
    const ZERO = "0",
      NINE = "9",
      LOWERA = "a",
      LOWERZ = "z",
      UPPERA = "A",
      UPPERZ = "Z",
      HYPHEN = "-",
      ARROWLEFT = "ArrowLeft",
      ARROWRIGHT = "ArrowRight",
      DELETE = "Delete",
      BACKSPACE = "Backspace",
      APOSTROPHE = "'",
      SPACE = " ",
      TAB = "Tab",
      key = ev.key;

    // TODO: Environment based validation is a last minute request but this needs to removed ASAP
    if (window && window.location) {
      const host = window.location.host;
      if (host && host.indexOf("lendingclub") > -1) {
        if (
          !(
            key === ARROWLEFT ||
            key === ARROWRIGHT ||
            key === SPACE ||
            (key >= LOWERA && key <= LOWERZ) ||
            (key >= UPPERA && key <= UPPERZ) ||
            key === APOSTROPHE ||
            key === DELETE ||
            key === BACKSPACE ||
            key === TAB ||
            key === HYPHEN
          )
        ) {
          ev.preventDefault();
        }
      }
    }

    if (
      !(
        (key >= ZERO && key <= NINE) ||
        key === ARROWLEFT ||
        key === ARROWRIGHT ||
        key === SPACE ||
        (key >= LOWERA && key <= LOWERZ) ||
        (key >= UPPERA && key <= UPPERZ) ||
        key === APOSTROPHE ||
        key === DELETE ||
        key === BACKSPACE ||
        key === TAB ||
        key === HYPHEN
      )
    ) {
      ev.preventDefault();
    }
  };

  generateMessage = (msgType, fieldName) => {
    const { nameType, firstNameMetadata, lastNameMetadata } = this.props,
      firstNameLength = firstNameMetadata.value.length,
      lastNameLength = lastNameMetadata.value.length,
      msgData = this.initMsgObj();

    if (msgType === "info") {
      let msg =
        "Enter your " +
        (fieldName === "firstname" ? "first name." : "last name.");
      msgData.info.firstname = {
        type: "info",
        id: `pf-${nameType}-firstname`,
        slug: "firstname",
        msg: msg,
      };
    } else {
      // error
      msgData.errors.firstname = {
        type: "error",
        id: `pf-${nameType}-firstname`,
        slug: "firstname",
      };

      msgData.errors.lastname = {
        type: "error",
        id: `pf-${nameType}-lastname`,
        slug: "lastname",
      };

      if (firstNameLength === 0 && lastNameLength === 0) {
        msgData.errors.firstname.msg = "First name is required.";
        msgData.errors.lastname.msg = "Last name is required.";

        firstNameMetadata.isValid = false;
        lastNameMetadata.isValid = false;

        firstNameMetadata.status = "invalid";
        lastNameMetadata.status = "invalid";
      } else if (firstNameLength > 0 && lastNameLength > 0) {
        if (firstNameMetadata.status === "invalid") {
          msgData.errors.firstname.msg = "Invalid first name.";
        } else {
          msgData.errors.firstname = {};
        }

        if (lastNameMetadata.status === "invalid") {
          msgData.errors.lastname.msg = "Invalid last name.";
        } else {
          msgData.errors.lastname = {};
        }
      } else if (firstNameLength === 0) {
        msgData.errors.firstname.msg = "First name is required.";
        firstNameMetadata.status = "invalid";

        if (lastNameLength > 0 && lastNameMetadata.status === "invalid") {
          msgData.errors.lastname.msg = "Invalid last name.";
        } else {
          msgData.errors.lastname = {};
        }
      } else if (lastNameLength === 0) {
        msgData.errors.lastname.msg = "Last name is required.";
        lastNameMetadata.status = "invalid";

        if (firstNameLength > 0 && firstNameMetadata.status === "invalid") {
          msgData.errors.firstname.msg = "Invalid first name.";
        } else {
          msgData.errors.firstname = {};
        }
      }
    }

    return msgData;
  };

  existSpecialChars = (str) => {
    // TODO: Environment based validation is a last minute request but this needs to removed ASAP
    let regex = /[\\(){}:;|!@#$%^&*_=+~`,"\/]/gi;
    if (window && window.location) {
      const host = window.location.host;
      if (host && host.indexOf("lendingclub") > -1) {
        regex = /^[a-zA-Z',\-. ]+$/gi;
        return regex.test(str);
      }
    }
    return !regex.test(str);
  };

  handleChange = (ev) => {
    const { name, value } = ev.target,
      { firstNameMetadata, lastNameMetadata } = this.props,
      elementValue = value.trim(),
      isValid = elementValue ? true : false;

    if (name === "firstname") {
      firstNameMetadata.value = elementValue;
      firstNameMetadata.isValid = isValid;
    } else if (name === "lastname") {
      lastNameMetadata.value = elementValue;
      lastNameMetadata.isValid = isValid;
    }
  };

  handleBlur = (ev) => {
    const { onEventCallback, firstNameMetadata, lastNameMetadata } = this.props,
      { value, name } = ev.target,
      nameValue = value.trim(),
      validName = nameValue && this.existSpecialChars(nameValue);

    let nameMetadata = {
        value: nameValue,
        isValid: validName ? true : false,
        status: validName ? "" : "invalid",
      },
      msgData = this.initMsgObj();

    if (name === "lastname") {
      firstNameMetadata.status =
        firstNameMetadata.value &&
        this.existSpecialChars(firstNameMetadata.value)
          ? ""
          : "invalid";
      lastNameMetadata.status = nameMetadata.status;
      if (
        !firstNameMetadata.value ||
        !lastNameMetadata.value ||
        firstNameMetadata.status === "invalid" ||
        lastNameMetadata.status === "invalid"
      ) {
        msgData = this.generateMessage("error", name);
      }
    } else if (name === "firstname") {
      // firstname
      msgData.info.firstname = {};
    }

    this.setState({ msgData });
    if (onEventCallback && typeof onEventCallback === "function") {
      onEventCallback(ev, nameMetadata);
    }
  };

  handleFocus = (ev) => {
    const { firstNameMetadata, lastNameMetadata } = this.props;

    firstNameMetadata.status = "";
    lastNameMetadata.status = "";

    this.setState({
      msgData: this.generateMessage("info", ev.target.name),
    });
  };

  render() {
    let autoCompleteFName = null,
      autoCompleteLName = null,
      { msgData } = this.state;
    const {
        colLayout,
        nameType,
        element,
        firstNameMax,
        lastNameMax,
        nameDisabled,
        nameGroupLabel,
        firstNameMetadata,
        lastNameMetadata,
      } = this.props,
      firstNameText = "firstname",
      lastNameText = "lastname",
      prefix = `pf-${nameType}-`,
      who = nameType === "recipient" ? "patRelationship" : "renderApplicant";

    if (nameType === "applicant" && nameDisabled) {
      firstNameMetadata.status = "";
      lastNameMetadata.status = "";
    }

    // future enhancement possibility: unset 'recipient' (autocomplete=null) first name and last name
    // when patient relationship !== 'self', since applicant is assumed to be the person
    // filling out the form (and who would benefit from autocomplete)

    // note: if patient relationship is 'self', applicant autocomplete is null (set above)
    if (nameType === "applicant" && !nameDisabled) {
      autoCompleteFName = firstNameMetadata.autocomplete;
      autoCompleteLName = lastNameMetadata.autocomplete;
      // this will usually get set, since 'recipient' is always !nameDisabled
    } else if (nameType === "recipient" && !nameDisabled) {
      autoCompleteFName = firstNameMetadata.autocomplete;
      autoCompleteLName = lastNameMetadata.autocomplete;
    }

    if (
      firstNameMetadata.status === "invalid" ||
      lastNameMetadata.status === "invalid"
    ) {
      msgData = this.generateMessage("error", "");
    }

    return (
      <Row className={prefix + element.name}>
        <Col className={element.colLabelClassName} width={colLayout[1]}>
          <label htmlFor={prefix + firstNameText}>{nameGroupLabel}</label>
        </Col>
        <Col className={element.colFieldClassName} width={colLayout[2]}>
          <input
            key={firstNameMetadata.value}
            id={prefix + firstNameText}
            className={firstNameMetadata.status}
            defaultValue={firstNameMetadata.value}
            name={firstNameText}
            type="text"
            placeholder={element.firstNameLabel}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            maxLength={firstNameMax}
            onKeyDown={this.validKey}
            disabled={nameDisabled}
            autoComplete={autoCompleteFName}
          />
        </Col>
        <Col className={element.colFieldClassName} width={colLayout[3]}>
          <label className="show-for-sr" htmlFor={prefix + lastNameText}>
            {element.lastNameLabel}
          </label>
          <input
            key={lastNameMetadata.value}
            id={prefix + lastNameText}
            className={lastNameMetadata.status}
            defaultValue={lastNameMetadata.value}
            name={lastNameText}
            type="text"
            placeholder={element.lastNameLabel}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            maxLength={lastNameMax}
            onKeyDown={this.validKey}
            disabled={nameDisabled}
            autoComplete={autoCompleteLName}
          />
        </Col>
        <Col className={element.colValidationClassName} width={colLayout[4]}>
          <ValidationMsg
            who={who}
            filterFields={[firstNameText, lastNameText]}
            msgs={msgData}
          />
        </Col>
      </Row>
    );
  }
}

Name.propTypes = {
  colLayout: PropTypes.object.isRequired,
  element: PropTypes.object.isRequired,
  onEventCallback: PropTypes.func,
  nameType: PropTypes.string.isRequired,
  firstNameMax: PropTypes.number.isRequired,
  lastNameMax: PropTypes.number.isRequired,
  nameDisabled: PropTypes.bool.isRequired,
  nameGroupLabel: PropTypes.string,
  firstNameMetadata: PropTypes.object.isRequired,
  lastNameMetadata: PropTypes.object.isRequired,
};

export default Name;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');